export enum UserQueueStatus {
    PAUSED = 'PAUSED',
    UNPAUSED = 'UNPAUSED',
}
